var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3566CC",
    d: "M24 44q-1.35 0-2.375-.65t-1.325-1.8h-.7q-1.2 0-2.1-.9-.9-.9-.9-2.1V31.4q-3.3-2.15-5.2-5.5-1.9-3.35-1.9-7.4 0-6.05 4.225-10.275Q17.95 4 24 4q6.05 0 10.275 4.225Q38.5 12.45 38.5 18.5q0 4.05-1.9 7.4-1.9 3.35-5.2 5.5v7.15q0 1.2-.9 2.1-.9.9-2.1.9h-.7q-.3 1.15-1.325 1.8Q25.35 44 24 44Zm-4.4-5.45h8.8v-2.2h-8.8Zm0-4.2h8.8v-2h-8.8Zm5.55-5V22.5l4.6-4.6-1.55-1.55-4.2 4.2-4.2-4.2-1.55 1.55 4.6 4.6v6.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuz);
export default __webpack_public_path__ + "static/media/luz.8093121aff1fb4127edbf3412cf2810b.svg";
export { ForwardRef as ReactComponent };